import React from 'react';
import { Modal } from 'react-bootstrap';
import Select from 'react-select';
import { Button } from 'reactstrap';
import './report.scss';
const MoreInfoPopup = (props) => {
  console.log('datamodelllllllll', props.data);
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      animation={true}
      className="modal"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter"></Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div
          style={{ display: 'flex', flexDirection: 'column', color: 'black' }}
        >
          <div style={{ padding: '5px 0px', wordBreak: 'break-all' }}>
            <span style={{ fontWeight: 700, color: 'black', paddingRight: 5 }}>
              Status:{' '}
            </span>
            {props.status}
          </div>
          <div style={{ padding: '5px 0px', wordBreak: 'break-all' }}>
            <span style={{ fontWeight: 700, color: 'black', paddingRight: 5 }}>
              Description:{' '}
            </span>
            {props.description}
          </div>
          <div style={{ padding: '5px 0px 30px 0px', wordBreak: 'break-all' }}>
            <span style={{ fontWeight: 700, color: 'black', paddingRight: 5 }}>
              Data File Name:{' '}
            </span>
            {props.data}
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default MoreInfoPopup;
